module.exports = __webpack_public_path__ + "img/salespersonFenXiang.91548d96.png";